import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {
  AuthSandbox,
  RoutesEnum,
  Icon,
  NavigationService,
  inputErrorTypes
} from '../../../modules/global';
import {catchError, debounceTime, map} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {rootStoreActions} from '../../+state';
import { ExternalPageContainerComponent } from '../../components/externap-page-container/external-page-container.component';
import { TranslateDirective } from '@ngx-translate/core';
import { TextInputComponent } from '../../../modules/shared/components/inputs/text-input/text-input.component';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '../../../modules/shared/components/buttons/button/button.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'slm-login',
    templateUrl: './login.container.html',
    imports: [ExternalPageContainerComponent, TranslateDirective, FormsModule, ReactiveFormsModule, TextInputComponent, RouterLink, ButtonComponent, AsyncPipe]
})
export class LoginContainer implements OnInit {
  private readonly fb = inject(UntypedFormBuilder);
  private readonly store = inject(Store);
  private readonly router = inject(NavigationService);
  private readonly authSandbox = inject(AuthSandbox);

  public readonly routes = RoutesEnum;
  public readonly isLoading$ = new BehaviorSubject<boolean>(false);
  public emailQueryParams$: Observable<any>;

  public readonly inputErrors = [
    inputErrorTypes.required,
    inputErrorTypes.email
  ];
  public loginForm: UntypedFormGroup;
  protected errors: any;
  public passwordInputType: 'password' | 'text' = 'password';
  public passwordInputIcon = Icon.VISIBILITY;

  ngOnInit() {
    // Form generation
    this.store.dispatch(rootStoreActions.logoutAction());
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
    const emailControl = this.loginForm.get('email');
    this.emailQueryParams$ = emailControl.valueChanges.pipe(
      debounceTime(500),
      map(value => emailControl.valid ? ({email: value}) : null)
    );
  }

  public login(): void {
    this.loginForm.markAllAsTouched();
    if (this.loginForm.invalid && this.isLoading$.getValue()) {
      return;
    }
    this.isLoading$.next(true);
    this.authSandbox
      .login(this.loginForm.value)
      .pipe(
        catchError((err) => {
          this.isLoading$.next(false);
          return throwError(err);
        })
      )
      .subscribe((navigated) => {
        this.isLoading$.next(false);
        if (!navigated) {
          this.router.navigate([RoutesEnum.HOME]);
        }
      });
  }

  public goToRegistration(): void {
    this.router.navigate([RoutesEnum.REGISTRATION]);
  }

  public passwordTypeChanged(): void {
    if ('password' === this.passwordInputType) {
      this.passwordInputIcon = Icon.VISIBILITY_OFF;
      this.passwordInputType = 'text';
    } else {
      this.passwordInputIcon = Icon.VISIBILITY;
      this.passwordInputType = 'password';
    }
  }
}
